module.exports = __webpack_public_path__ + "static/media/Arrow-up-gray.247dc7b3.svg";